import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { copySingleProductToCart } from './copySingleProductToCart';
import { singleUpdateToCart } from './singleUpdateToCart';
import { convertUsageConditionToUsageConditionDto } from '../../shared/utils/convertLineItemKey';
import { UpdateProductOptions } from '../../store/api';
import { SOURCE_SELECTIONLIST } from '../../store/constants';
import { useNotification } from '../../app-store/notification/useNotification';

type CopyToCartParams = {
    sourceListId: string;
    callback: () => void;
};

export const useCopyToCart = ({ sourceListId, callback }: CopyToCartParams) => {
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const { showNotificationWithInfo } = useNotification();

    return {
        isLoading,
        addToCart: (options: UpdateProductOptions, performChecks: boolean) => {
            const apiCallback = () => {
                return copySingleProductToCart({
                    productId: options.id,
                    body: {
                        usageCondition: convertUsageConditionToUsageConditionDto(options.price),
                        subscriptionPeriodType: options.targetSubscriptionPeriodType,
                        sourceSelectionListId: sourceListId
                    },
                    params: {
                        performChecks
                    }
                });
            };

            return singleUpdateToCart({
                t,
                setLoading,
                performChecks,
                source: SOURCE_SELECTIONLIST,
                notificationMessage: t('notifications.getMessageFromActionCart.copy', { productTitle: options.title }),
                apiCallback,
                callback,
                showNotificationWithInfo
            });
        }
    };
};
